import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b1cf02ea&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1cf02ea')) {
      api.createRecord('b1cf02ea', component.options)
    } else {
      api.reload('b1cf02ea', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=b1cf02ea&", function () {
      api.rerender('b1cf02ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/List.vue"
export default component.exports